import React, {useState} from "react";
import FilterContainer from "./filter/FilterContainer";
import SliderContainer from "./slider/SliderContainer";
import CardContainer from "./card/CardContainer";
import Title from "./shared/Title";
import {PATH} from "../../config";

const DiscoveryContainer = () => {

    const [searchField, setSearchField] = useState('');

    const card = [
        {
            bg: PATH+'metahut-owner.jpg',
            title: "by Tuivasa Sheck",
            active: true,
            stats: [
                {
                    icon: "pin",
                    label: "A7-346"
                },
                {
                    icon: "people",
                    label: "3,445 "
                },
                {
                    icon: "eye",
                    label: "123,445 "
                },
            ],
            linkLabel: "Jump in",
            linkIcon: "right-circle",
        },
        {
            bg: PATH+'metahut-owner.jpg',
            title: "by Laetitia Lo Iudice",
            active: true,
            stats: [
                {
                    icon: "pin",
                    label: "A7-346"
                },
                {
                    icon: "people",
                    label: "3,445 "
                },
                {
                    icon: "eye",
                    label: "123,445 "
                },
            ],
            linkLabel: "Jump in",
            linkIcon: "right-circle",
        },
        {
            bg: PATH+'metahut-owner.jpg',
            title: "by Camilla Guli",
            active: true,
            stats: [
                {
                    icon: "pin",
                    label: "A7-346"
                },
                {
                    icon: "people",
                    label: "3,445 "
                },
                {
                    icon: "eye",
                    label: "123,445 "
                },
            ],
            linkLabel: "Jump in",
            linkIcon: "right-circle",
        },
        {
            bg: PATH+'metahut-owner.jpg',
            title: "by Ruby Red",
            active: true,
            stats: [
                {
                    icon: "pin",
                    label: "A7-346"
                },
                {
                    icon: "people",
                    label: "3,445 "
                },
                {
                    icon: "eye",
                    label: "123,445 "
                },
            ],
            linkLabel: "Jump in",
            linkIcon: "right-circle",
        },
    ]

    const onSearchChange = (e) => {
        const searchString = e.target.value.toLocaleLowerCase();
        setSearchField(searchString);
        console.log(searchField, searchString)
    }

    const filteringCards = card.filter((cardFilter) => {
        return cardFilter.title.toLocaleLowerCase().includes(searchField)
    })

    console.log({filteringCards: filteringCards})


    // const navigate = useNavigate();

    // const handleSubmit = event => {
    //     event.preventDefault();
    //
    //     // 👇️ redirect to /
    //     if(filteringCards.length > 0) {
    //         navigate('/metahuts/mycollection', {replace: true});
    //     }
    //
    // };
    return (
        <>
            {/*<form onSubmit={handleSubmit}>*/}
            {/*    <Input*/}
            {/*        placeholder="Search metahuts"*/}
            {/*        className="bg-indigo-900 rounded-3xl search w-60 h-11 text-base text-white"*/}
            {/*        allowClear*/}
            {/*        prefix={<i className="icon-search text-2xl"></i>}*/}
            {/*        onChange={onSearchChange}*/}
            {/*    />*/}
            {/*</form>*/}
            <div className="mt-20">
                <FilterContainer onSearchChange={onSearchChange} />
            </div>
            <Title title="New" className="px-8 mb-9 text-white uppercase font-normal" />
            <SliderContainer PATH={PATH} />
            <Title title="Trending" className="px-8 mb-9 text-white uppercase font-normal" />
            <CardContainer card={filteringCards} />
        </>
    )
}

export default DiscoveryContainer;